import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient, HttpHeaders} from '@angular/common/http';

const PAYMENT_ROUTES = {
  SET_SUBSCRIPTION_PLAN: 'payments/web/store',
  UPGRADE_SUBSCRIPTION_PLAN: 'payments/web/upgrade',
  CANCEL_SUBSCRIPTION: 'payments/web/cancel',
  RESUME_SUBSCRIPTION: 'payments/web/resume',
  GET_CURRENT_PLAN: 'payments/web/userSubscription'
};

@Injectable({
  providedIn: 'root'
})
export class PaymentHttpService {
  constructor(private httpClient: HttpClient) {}

  private setSubscriptionPlanReq(bodyParam: any): Observable<any> {
    return this.httpClient.post(PAYMENT_ROUTES.SET_SUBSCRIPTION_PLAN, bodyParam) as any;
  }

  setSubscriptionPlan(bodyParam: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.setSubscriptionPlanReq(bodyParam).subscribe((res: any) => {
        resolve(res);
      }, error => {
        reject(error);
      });
    });
  }

  private upgradeSubscriptionPlanReq(bodyParam: any): Observable<any> {
    return this.httpClient.post(PAYMENT_ROUTES.UPGRADE_SUBSCRIPTION_PLAN, bodyParam) as any;
  }

  upgradeSubscriptionPlan(bodyParam: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.upgradeSubscriptionPlanReq(bodyParam).subscribe((res: any) => {
        resolve(res);
      }, error => {
        reject(error);
      });
    });
  }

  private getCurrentSubscriptionPlanReq(): Observable<any> {
    return this.httpClient.get(PAYMENT_ROUTES.GET_CURRENT_PLAN) as any;
  }

  getCurrentSubscriptionPlan(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.getCurrentSubscriptionPlanReq().subscribe((res: any) => {
        resolve(res);
      }, error => {
        reject(error);
      });
    });
  }

  private cancelSubscriptionPlanReq(bodyParams: any): Observable<any> {
    return this.httpClient.post(PAYMENT_ROUTES.CANCEL_SUBSCRIPTION, bodyParams) as any;
  }

  cancelSubscriptionPlan(bodyParams: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.cancelSubscriptionPlanReq(bodyParams).subscribe((res: any) => {
        resolve(res);
      }, error => {
        reject(error);
      });
    });
  }

  private resumeSubscriptionPlanReq(): Observable<any> {
    return this.httpClient.post(PAYMENT_ROUTES.RESUME_SUBSCRIPTION, {}) as any;
  }

  resumeSubscriptionPlan(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.resumeSubscriptionPlanReq().subscribe((res: any) => {
        resolve(res);
      }, error => {
        reject(error);
      });
    });
  }
}
